import ModalViewFilter from "../components/modal-view-filter";

const SELECTORS = {
  component: ".views-exposed-form",
};

window.Drupal.behaviors.app_fund_article_archive = {
  attach: (context, settings) => {
    const components = [...context.querySelectorAll(SELECTORS.component)];

    // eslint-disable-next-line no-restricted-syntax
    for (const component of components) {
      const ModalViewFilterInstance = new ModalViewFilter(component);
      ModalViewFilterInstance.init();
    }
  },
};
